import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { requestPasswordReset } from '../utils/supabase'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setMessage('')

    if (!email.trim()) {
      setError('Please enter your email address')
      setLoading(false)
      return
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email.trim())) {
      setError('Please enter a valid email address')
      setLoading(false)
      return
    }

    try {
      const result = await requestPasswordReset(email.trim())
      
      if (!result.success) {
        setError(result.error.message)
      } else {
        setMessage(result.message)
        setEmail('') // Clear the email field on success
      }
    } catch (error) {
      console.error('Password reset error:', error)
      setError('An unexpected error occurred. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Task Manager</h1>
        <h2>Reset Your Password</h2>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" disabled={loading} className="auth-button">
            {loading ? 'Sending Reset Link...' : 'Send Password Reset Link'}
          </button>
        </form>
        
        <p>
          Remember your password?{' '}
          <Link to="/" className="link-button">
            Back to Sign In
          </Link>
        </p>
        
        <div className="info-box" style={{ marginTop: '20px', padding: '12px', backgroundColor: '#f0f8ff', borderRadius: '6px', fontSize: '14px' }}>
          <p style={{ margin: '0 0 8px 0' }}><strong>Security Note:</strong></p>
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            <li>You can request up to 3 password resets per hour</li>
            <li>Check your spam folder if you don't see the email</li>
            <li>The reset link will expire after a certain time</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword